import { TFunction } from "i18next"
import moment from "moment"
import { translationKeys } from "../../util/translationKeys"

export const formatRestaurantOpeningTime = (
  date: string | undefined,
  t: TFunction
) => {
  if (!date) {
    return null
  }
  const todayTranslation = t(translationKeys.webRestaurantToday)
  const tomorrowTranslation = t(translationKeys.webRestaurantTomorrow)
  const momentDate = moment(date)
  const today = moment()
  const tomorrow = moment().add(1, "days")

  if (momentDate.isSame(today, "day")) {
    return momentDate.format(`HH:mm [${todayTranslation}]`)
  }

  if (momentDate.isSame(tomorrow, "day")) {
    return momentDate.format(`HH:mm [${tomorrowTranslation}]`)
  }

  return momentDate.format("HH:mm, dddd")
}
